// API Configuration
import { getApiUrl } from './environment';

const API_BASE_URL = getApiUrl();

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  TIMEOUT: 30000, // Aumentado para 30 segundos
  HEADERS: {
    'Content-Type': 'application/json',
  },
};

export default API_CONFIG; 